import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Edit pass</Typography>
    <p>Use this page to override editable template variables for this one pass. The template value is shown for reference; enable an override only when this pass needs a different value.</p>
    <Typography variant='h5'>Validation and saving</Typography>
    <p>Only editable variables are listed. Read-only and encrypted variables are excluded. Values are validated against the template variable type before Save is enabled. Saving updates this pass and triggers platform updates where needed.</p>
    <Typography variant='h5'>Returning to the table</Typography>
    <p>Use the close button to return to Manage Passes. The loaded rows, current filters and sort order are retained for the same template.</p>
  </div>
)

export default HelpText
